<template>
  <div class="navigation" :class="this.aName == 'home' ? 'navigation_dx' : ''">
    <div class="nav_m">
      <div class="logo">

        <a href="/"><img src="@/assets/images/logo.png" alt="" /></a>
      </div>
      <div class="navs">
        <ul>
          <li>
            <div class="bka" :class="this.aName == 'home' ? 'active' : ''">
              <router-link to="/" class="nava">首页</router-link>
            </div>
          </li>
          <li>
            <div class="bka" :class="this.aName == 'nhlist' ? 'active' : ''">
              <router-link to="/nhlist" class="nava">新房</router-link>
            </div>
          </li>
          <li>
            <div class="bka" :class="this.aName == 'lease' ? 'active' : ''">
              <router-link to="/lease" class="nava">租房</router-link>
            </div>
          </li>
          <li @mouseleave="mouseLeaveFun">
            <div
              class="bka"
              :class="this.aName == 'esf' ? 'active' : ''"
              @mouseover="subleveldownFun(4)"
            >
              <router-link to="/esf" class="nava">二手房</router-link>
            </div>
            <div class="bkb" :class="this.subleveldown == 4 ? 'show' : ''">
              <dd>
                <router-link to="/community" class="navab"
                  >楼盘字典</router-link
                >
              </dd>
                <dd><router-link to="/adviser" class="navab">小区专家</router-link></dd>
            </div>
          </li>
          <li>
            <div class="bka" :class="this.aName == 'business' ? 'active' : ''">
              <router-link to="/business" class="nava">商业地产</router-link>
            </div>
          </li>
          <li>
            <div
              class="bka"
              :class="this.aName == 'housingprice' ? 'active' : ''"
            >
              <router-link to="/housingprice" class="nava">房价</router-link>
            </div>
          </li>
          <li>
            <div
              class="bka"
              :class="this.aName == 'decoration' ? 'active' : ''"
            >
              <router-link to="/decoration" class="nava">装修</router-link>
            </div>
          </li>
          <li>
            <div class="bka" :class="this.aName == 'louxun' ? 'active' : ''">
              <router-link to="/louxlist" class="nava">楼讯</router-link>
            </div>
          </li>
          <li>
            <div class="bka" :class="this.aName == 'tourism' ? 'active' : ''">
              <router-link to="/tourism" class="nava">旅游地产</router-link>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="IndividualUsers" style="cursor: pointer" v-if="!user || !user.id" @click="this.logininput=true">
      注册/登录
    </div>
    <div class="IndividualUsers" v-else>
        {{user.nickname}}
    </div>
  </div>
  <div class="navigation_h" :style="{backgroundImage:'url('+navhimg+')'}"></div>
  <!-- <div
    class="navigation_h"
    :style="{ backgroundImage: 'url(' + navhimg + ')' }"
    v-if="this.aName != 'home'"
  ></div> -->
  <!-- 登录窗口 -->
  <div id="loginBox" style="display: block" v-if="logininput==true"><div class="close" style="margin-right: 25px;
    text-align: right;
    cursor: pointer;
    color: white;
    margin-top: 20px;
    font-size: 20px;" @click="close">X</div>
    <div class="loginbac">
      <div class="loginBox_tel commonBox" v-show="displays=='quick'">
        <div class="telbox commonBox_c">
          <span class="close" @click="close">X</span>
          <p class="tittle">手机快捷登录<span class="register"></span></p>
          <div class="fromlogin">
            <div id="loding_tencenthuakuai" style="display: none">
              加载中. . .
            </div>
            <div class="inputbox">
              <input type="text" v-model="form.mobile" name="mobile" placeholder="请输入手机号" />
            </div>
            <div class="inputbox border_b">
              <input v-model="form.code"
                type="text"
                name="codeTel"
                placeholder="请输入短信验证码"
              />
              <span class="codetext" data-type="login" @click="getSmsCode">{{djs > 0 ? `${djs}秒后获取` : "获取验证码"}}</span>
            </div>
            <div class="remember">
              <label for="rememberword"
                ><input v-model="form.week"
                  type="checkbox"
                  name="remember"
                  checked=""
                  id="rememberword"
                  value="" />7天内免登录<span class="icon"></span
              ></label>
            </div>
            <button class="login_tel" @click="mobileLogin">登录</button>
            <div class="login_way">
<!--             <p class="changeUser" data-type="2" @click="displays='accountpwd'">账号密码登录</p>-->
              <p class="way" style="width: 100%" @click="openWxCommonLogin();">微信扫码登录</p>
            </div>
            <p class="xieyi">
              登录即代表同意<a href="javascript:;" @click="this.$router.push('/serviceAgreement')"
                >《湖州有房网用户服务协议》</a
              >
              并授权手机号给湖州有房网为您提供服务
            </p>
          </div>
        </div>
      </div>
      <div class="confirmBox_tel commonBox" v-show="displays=='binding'" >
        <div class="telbox commonBox_c">
          <span class="close" @click="close">X</span>
          <p class="tittle">绑定手机号<span class="register"></span></p>
          <div class="fromlogin">
            <div class="inputbox">
              <input type="text" name="mobile" placeholder="请输入手机号" />
            </div>
            <div class="inputbox border_b">
              <input
                type="text"
                name="codeTel"
                placeholder="请输入短信验证码"
              /><span class="codetext" data-type="login">获取验证码</span>
            </div>
            <button class="login_tel">绑定手机号</button>
            <p class="xieyi">
              登录即代表同意<a href="https://www.loupan.com/about/agreement"
                >《楼盘网用户服务协议》</a
              >
              并授权手机号给楼盘网为您提供服务
            </p>
          </div>
        </div>
      </div>
      <div class="accountBox_tel commonBox" v-show="displays=='accountpwd'">
        <div class="accountbox commonBox_c">
          <span class="close" @click="close">X</span>
          <p class="tittle">账号密码登录<span class="register" @click="displays='phone'">注册</span></p>
          <div class="fromlogin">
            <div class="inputbox">
              <input type="text" name="mobile" placeholder="请输入手机号" />
            </div>
            <div class="inputbox border_b">
              <input type="password" name="psw" placeholder="请输入密码" />
            </div>
            <div class="remember">
              <label for="rememberword1"
                ><input
                  type="checkbox"
                  name="remember"
                  checked=""
                  id="rememberword1"
                  value=""
                />7天内免登录<span class="icon"></span>
              </label>
              <p class="forget" @click="displays='forget'">忘记密码</p>
            </div>
            <button class="login_tel">登录</button>
            <div class="login_way">
              <p class="changeUser" data-type="1" @click="displays='quick'">手机号快捷登录</p>
              <p class="way" onclick="openWxCommonLogin();">微信扫码登录</p>
            </div>
            <p class="xieyi">
              登录即代表同意<a href="https://www.loupan.com/about/agreement"
                >《楼盘网用户服务协议》</a
              >
              并授权手机号给楼盘网为您提供服务
            </p>
          </div>
        </div>
      </div>
      <div class="registerBox_tel commonBox"  v-show="displays=='phone'">
        <div class="registerbox commonBox_c">
          <span class="close" @click="close">X</span>
          <p class="tittle">手机号注册</p>
          <div class="switchRoles">
            <label for="ordinary"
              ><input
                type="radio"
                class="switchbtm"
                name="roles"
                id="ordinary"
                value="" />
              普通用户<span class="icon"></span></label
            ><label for="agent"
              ><input
                type="radio"
                class="switchbtm"
                name="roles"
                id="agent"
                value="" />
              经纪人<span class="icon"></span
            ></label>
          </div>
          <p class="ms">注册成功后自动登录注册账号</p>
          <div class="fromlogin">
            <div class="inputbox">
              <input type="text" name="mobile" placeholder="请输入手机号" />
            </div>
            <div class="inputbox">
              <input
                type="text"
                name="codeTel"
                placeholder="请输入短信验证码"
              /><span class="codetext" data-type="register">获取验证码</span>
            </div>
            <div class="inputbox border_b">
              <input
                type="password"
                class="checkPsw"
                name="psw"
                placeholder="请输入密码"
              /><span class="icon_ts"></span>
            </div>
            <p class="msg"></p>
            <button class="login_tel wt">注册</button>
            <div class="login_way">
              <p class="changeUser" data-type="2" @click="displays='accountpwd'">账号密码登录</p>
              <p class="way" onclick="openWxCommonLogin();">微信扫码登录</p>
            </div>
            <p class="xieyi">
              注册即代表同意<a href="https://www.loupan.com/about/agreement"
                >《楼盘网用户服务协议》</a
              >
            </p>
          </div>
        </div>
      </div>
      <div class="forgetBox_tel commonBox" v-show="displays=='forget'">
        <div class="forgetbox commonBox_c">
          <span class="close" @click="close">X</span>
          <p class="tittle">忘记密码</p>
          <div class="fromlogin">
            <div class="inputbox">
              <input type="text" name="mobile" placeholder="请输入手机号" />
            </div>
            <div class="inputbox">
              <input
                type="text"
                name="codeTel"
                placeholder="请输入短信验证码"
              /><span class="codetext" data-type="change-password"
                >获取验证码</span
              >
            </div>
            <div class="inputbox border_b">
              <input
                type="password"
                class="checkPsw"
                name="psw"
                placeholder="请输入密码"
              /><span class="icon_ts"></span>
            </div>
            <p class="msg"></p>
            <button class="login_tel">确认修改</button>
            <div class="login_way">
              <p class="changeUser" data-type="1" @click="displays='quick'">手机号快捷登录</p>
              <p class="way" onclick="openWxCommonLogin()">微信扫码登录</p>
            </div>
          </div>
        </div>
      </div>
      <div class="forgetBox_tel commonBox" v-show="displays=='wx'">
        <div class="forgetbox commonBox_c">
          <div id="wx_qr_code"></div>
        </div>
      </div>
      <div class="forgetBox_tel commonBox" v-show="displays=='bd'">
        <div class="forgetbox commonBox_c">
          <binding @bindSucc="() => {logininput = false; displays=''}"  />
        </div>
      </div>
    </div>
  </div>
  <prompts :titleinformarion="titleinformarion"
       :informarion="informarion" style="display: none"
        id="proo"></prompts>



        <!-- <div class="qrcode_div_ewm"  >
      <qrcode-vue :value="value" :size="size"></qrcode-vue>
    </div> -->
    <!-- 提示
    <div class="prompts" v-if="opacity == true">
    <div class="informarion">提交失败</div>
    <div>请输入手机号码!</div>
  </div> -->
    <!-- 提示 -->
    <!-- <div class="prompts" id="prompts"  :style="opacity == true?'opacity:0.7':''">
    <div class="informarion">{{ titleinformarion }}</div>
    <div>{{ informarion }}!</div>
  </div> -->

</template>

<script>
import { ref } from "vue";
import axios from "axios";
import Api from "@/api/api"
import {useStore} from "vuex";
import global from "@/global.vue"
import prompts from './prompts.vue'
import binding from './binding.vue'
import util from "@/utils/util";
//引入jquery
import $ from "jquery";
import QrcodeVue from "qrcode.vue";
export default {
  components: {
    prompts,
    binding
},
  setup() {
    //二手房下拉
    const subleveldown = ref(0);
    //移入
    const subleveldownFun = (index) => {
      subleveldown.value = index;
    };
    //移出
    const mouseLeaveFun = () => {
      subleveldown.value = 0;
    };
    return {
      subleveldown,
      subleveldownFun,
      mouseLeaveFun,
    };
  },
  data() {
    return {
      active:false,
      titleinformarion:"",
      informarion:"",
      opacity: false,
      // 设置为bd跳转到绑定手机号弹框,wx弹出二维码
		  displays:"quick",
      footermobile: "",
      footername: "",
      aName: "",
	    logininput:false,
      //导航背景图，首页不展示
      navhimg: require("@/assets/images/header_bj.jpg"),
      djs: 0,
      form: {
          mobile: "",
          code: "",
          week: true
      },
      user: {},
        store:null
    };
  },
  props: ["active"],
  mounted() {
    this.store = useStore();
    this.user = this.store.state.user;
    this.huitop();
    this.getUserInfo();
  },
  created() {
    this.aName = this.active; //高亮标识赋值
    //console.log(this.active);
  },
  methods: {
    // 提示方法
    prompts(titleinformarion,informarion) {
      this.titleinformarion=titleinformarion
      this.informarion=informarion
      // this.opacity = true;
      let proo=  document.getElementById("proo")
      proo.style.opacity=0.7;
      proo.style.display = "block";
      let timer = setInterval(function () {
        var proo=  document.getElementById("proo")
            proo.style.opacity=0
        clearInterval(timer);
      }, 3000);
    },
      getSmsCode() {
        if (this.form.mobile && this.djs <= 0) {
            Api.Login.sendSmsCode(this.form.mobile).then(res => {
                this.djs = 60;
                this.form.s_id = res.s_id;
                let t = setInterval(() => {
                    this.djs-- > 0 || clearInterval(t)
                }, 1000)
            });
        }
      },
      setUserInfo(user) {
        if (user) {
          this.user = user;
          this.store.commit("setUser", user);
          if (!user.invite_emp_id) {
              Api.User.employeeBind();
          }
          if (!user.mobile) {
              console.log('no mobile');
              this.displays = "bd";
              this.logininput=true
          }
        }

      },
      getUserInfo() {
          let pr = new Promise((resolve, reject) => {
              let hzToken = localStorage.getItem(global.tokenKey);
              if (hzToken) {
                  if (!this.user || !this.user.id) {
                      Api.User.info().then(user => {
                          this.setUserInfo(user);
                          resolve(this.user)
                      }, reject)
                  }else {
                    resolve(this.user)
                  }
              } else {
                reject();
              }
          })
          pr.then(() => {}, () => {
              let code = this.$route.query.code;
              if (code) {
                  this.$route.query.code = "";
                  Api.Login.wxLogin(code).then(res => {
                      // this.user = res.user;
                      // this.store.commit("setUser", res.user);
                      localStorage.setItem(global.tokenKey, res.token);
                      this.setUserInfo(res.user);
                  })
              }
          });
      },
      mobileLogin() {
         let form = this.form;
         if (!form.s_id) {
          console.log(3);
          // this.opacity=true
          this.prompts("请先获取验证码","请先获取验证码")
             return;
         }
         if (form.mobile && form.code) {
             Api.Login.mobileLogin(form.mobile, form.code, form.s_id, form.week).then(res => {
                 // this.user = res.user;
                 // this.store.commit("setUser", res.user);
                 localStorage.setItem(global.tokenKey, res.token);
                 this.setUserInfo(res.user);
                 this.close();
             })
         }
      },
    // 微信扫码
    openWxCommonLogin(){
        this.displays="wx";
        util.loadJs("//res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js").then(() => {
            new WxLogin({
                self_redirect:false,
                id:"wx_qr_code", // 显示微信登录二维码的容器
                appid: "wx91264b873e03941c",
                scope: "snsapi_login",
                redirect_uri: encodeURI("http://www.hzyfw.cn"),
                state: "",
                style: "",
                href: ""
            });
        })
    },
	// 弹出登录窗口
    login() {
	  this.logininput=true
    },
	// 关闭登录窗口
	close(){
		this.displays='quick'
		this.logininput=false
	},
    footeryuyue() {
      const that = this;
      const regex = /^1[3456789]\d{9}$/; //使用此正则即可
      if (!regex.test(that.footermobile)) {
        this.$message({
          showClose: true,
          message: "请输入正确的手机号",
          type: "error",
          duration: 2000,
          center: true,
          offset: 150,
        });

        return false;
      } else {
        let data = {
          type: "newhouse",
          id: 1,
          name: that.footername,
          mobile: that.footermobile,
        };
        axios
          .get(this.globalUrl + "/api/home/signinfo")
          .then(function (response) {
            if (response.data.code == 1) {
              this.$message({
                showClose: true,
                message: "提交成功",
                type: "success",
                duration: 2000,
                center: true,
                offset: 150,
              });

              that.$router.go(0);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    huitop() {
      //滑动到页面顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>

.navigation_h {
  width: 100%;
  height: 118px;
  background-size: cover !important;
}
.navigation {
  height: 118px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.navigation_dx {
  border-bottom: solid 1px #c9d9e8;
}
.nav_m {
  min-width: 1200px;
  height: 100%;
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.logo {
  margin-top: 18px;
  height: 80px;
}
.logo img {
  height: 100%;
}
.navs {
  display: inline-block;
  margin-top: 42px;
  margin-right: 93px;
}
.navs ul li {
  display: inline-block;
  margin-left: 12px;
  position: relative;
}
.navs ul li .bka {
  border-radius: 25px;
  -o-transition: all 0.5s;
  -moz-transition: all 0.5s;
  -ms-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}

.navs ul li .bkb {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: rgba(255, 157, 102, 1);
  border-radius: 5px;
  overflow: hidden;
}
.navs ul li .bkb.show {
  display: block;
}
.navs ul li .nava {
  color: #ffffff;
  font-size: 20px;
  padding: 6px 20px;
  border-radius: 25px;
  line-height: 24px;
  display: block;
}
.navs ul li .bkb dd {
  width: 100%;
  text-align: center;
  font-size: 14px;
  padding: 5px 0;
  color: #ffffff;
  overflow: hidden;
}
.navs ul li .bkb dd .navab {
  color: #ffffff;
}
.navs ul li .bkb dd:hover {
  background: #f64e1a;
}

.navs ul li:hover .bka {
  background: #ff9d66;
}
.navs ul li .bka.active {
  background: #ff9d66;
}
.IndividualUsers {
  color: white;
  position: relative;
    /*right: -150px;*/
}
#loginBox,
.statusPop,
.statusPop1 {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  z-index: 100;
  display: none;
}
#loginBox .loginbac {
  width: 380px;
  position: absolute;
  left: 50%;
  margin-left: -190px;
  top: 150px;
}
#loginBox .loginbac .commonBox {
  width: 380px;
  background-color: #ffffff;
  border-radius: 10px;
}
#loginBox .loginbac .commonBox .commonBox_c {
  padding: 30px;
}
#loginBox .loginbac .commonBox .commonBox_c .close {
  color: 666;
  font-size: 18px;
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
}
#loginBox .loginbac .commonBox .commonBox_c .tittle {
  font-size: 20px;
  color: #000000;
  font-weight: bold;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin {
  width: 100%;
  padding: 20px 0 0 0;
  position: relative;
}
#loding_tencenthuakuai {
  width: 100%;
  height: 100px;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 10;
  color: white;
  overflow: hidden;
  text-align: center;
  line-height: 100px;
  transition: 1s;
  border: solid 1px #cbcbcb;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .inputbox {
  position: relative;
  width: 100%;
  height: 50px;
  border: solid 1px #cbcbcb;
  border-bottom: 0;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .inputbox input {
  width: 317px;
  height: 48px;
  text-indent: 10px;
  margin-left: 1px;
  border: 0;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .inputbox .codetext {
  display: inline-block;
  position: absolute;
  top: 13px;
  right: 15px;
  font-size: 14px;
  color: #333333;
  cursor: pointer;
  padding-left: 25px;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .remember label {
    cursor: pointer;
    font-size: 14px;
    color: #666666;
    position: relative;
    padding-left: 15px;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .remember input {
    display: none;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .remember span {
    display: inline-block;
    width: 12px;
    height: 12px;
    background: url(../../assets/images/gou1.png)no-repeat center;
    background-size: 12px;
    position: absolute;
    left: 0;
    top: 1px;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .remember input:checked + span {
    background: url(../../assets/images/gou.png)no-repeat center;
    background-size: 12px;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .changeUser {
    cursor: pointer;
    font-size: 14px;
    color: #30a15d;
    margin-top: 15px;
}
.login_way .way {
    text-align: right;
    cursor: pointer;
    font-size: 14px;
    margin-top: 15px;
}
.login_way p {
    width: 50%;
    float: left;
    cursor: pointer;
    color: #30a15d;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .inputbox.border_b {
  border-bottom: solid 1px #cbcbcb;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .remember {
  margin-top: 15px;
  position: relative;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .login_tel {
  cursor: pointer;
  width: 100%;
  height: 50px;
  background-color: #30a15d;
  border-radius: 4px;
  font-size: 16px;
  color: #ffffff;
  margin-top: 20px;
  border: 0;
}
.login_way {
  width: 100%;
  height: 40px;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .xieyi {
  font-size: 12px;
  color: #999999;
  margin-top: 14px;
}
dl, dd, p {
    margin-bottom: 0;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .remember .forget {
    position: absolute;
    right: 0;
    cursor: pointer;
    color: #30a15d;
    display: inline-block;
}
#loginBox .loginbac .commonBox .commonBox_c .tittle .register {
    float: right;
    font-size: 14px;
    color: #30a15d;
    margin-top: 5px;
    font-weight: 500;
    cursor: pointer;
}
#loginBox .loginbac .commonBox .commonBox_c .ms {
    font-size: 14px;
    color: #999;
    margin-top: 14px;
}
#loginBox .loginbac .commonBox .commonBox_c .switchRoles {
    margin-top: 15px;
}
#loginBox .loginbac .commonBox .commonBox_c .switchRoles input:checked + span {
    background: url(../../assets/images/checked4.png)no-repeat center;
}
#loginBox .loginbac .commonBox .commonBox_c .switchRoles span {
    display: inline-block;
    width: 16px;
    height: 16px;
    position: absolute;
    left: 0;
    top: 1px;
    background: url(../../assets/images/checked3.png)no-repeat center;
}
#loginBox .loginbac .commonBox .commonBox_c .switchRoles label {
    cursor: pointer;
    font-size: 14px;
    color: #333333;
    position: relative;
    padding-left: 19px;
    margin-right: 10px;
}
#loginBox .loginbac .commonBox .commonBox_c .switchRoles input {
    display: none;
}
.eqrcode_div_active {
    top: 0 !important;
    opacity: 1 !important;
}
.eqrcode_div {
    width: 100%;
    height: 100%;
    top: -100%;
    opacity: 0;
    left: 0;
    background: rgba(0,0,0,0.7);
    position: fixed;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s;
}

</style>
